import React from 'react'
import STPSelectionBase from './../../Components/STPSelection/STPSelectionBase'
const STPSelection = () => {
  return (
    <STPSelectionBase 
      pageType="dp"
      title="Shipping Info"
      saveButtonLabel="Continue"
      navigationPaths={{
        buyerRolesParam: {
          is_ship_to_party: true,
          is_sell_to_buyer: false,
        },
        checkout: '/dp/checkout',
        selectedShipToParty: '/dp-shiping-info',
        onboardBuyer: '/onboard-buyer'
      }}
    />
  )
}

export default STPSelection